import React from "react"

import CommunityViewParticipantsListContainer from "./CommunityViewParticipantsListContainer"

const CommunityViewPartipants = ({
    type,
    communityId,
    participantTypes,
    selectedParticipantType,
    searchTerm,
    pagingRequest,
    onTypeChange,
    onSearch
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-community-people" /> People
        </h3>
        <div className="search-bar-container">
            <span className="searchicon">
                <input
                    className="form-control"
                    value={searchTerm}
                    type="search"
                    placeholder="search"
                    onChange={onSearch}
                />
            </span>
        </div>
        <select
            className="form-control"
            value={selectedParticipantType}
            onChange={onTypeChange(pagingRequest)}
        >
            {participantTypes.map(({ label, value }) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </select>
        <CommunityViewParticipantsListContainer
            type={type}
            communityId={communityId}
        />
    </div>
)

export default CommunityViewPartipants
